import React from 'react';
import { useParams } from 'react-router-dom';

import AdminTablePageLayout from 'components/admin/AdminTablePageLayout';
import MeetRegistrationManager from 'components/meet/MeetRegistrationManager';

// §6.10 — Case 1: a member / guest / visitor of the HOST club manages their own athletes' registrations for a multi-club
// meet, INSIDE the club app shell. The page is now just the club chrome; the shared MeetRegistrationManager renders its
// own meet hero (title + "Meet Details" link) and the registration dashboard — the same component the personal-portal
// Case 2 page (MyMeetSignup) uses.

const MyMeetRegistrations = () => {
  const { meetId } = useParams();

  return (
    <AdminTablePageLayout loading={false}>
      <MeetRegistrationManager meetId={meetId} />
    </AdminTablePageLayout>
  );
};

export default MyMeetRegistrations;
